export const version = '2.45.0';
//# sourceMappingURL=version.js.map